import React from 'react'
import { Footer } from '../../components/Footer'
import { Header } from '../../components/Header'
import HeadMeta from '../../components/HeadMeta'

const CompanyMediaPage = () => {
  return (
    <div>
      <HeadMeta title="CM・メディア掲載 | 企業情報 | 株式会社ベツダイ" description="マイホームはマイライフ。ベツダイがずっと大切にしているこの想いは、今までも、そしてこれからも変わることはありません。これからの時代と響き合う家づくりへ。私たちのチャレンジは続きます。" />
      <noscript>
        &lt;style&gt;body{'{'}visibility:visible{'}'}&lt;/style&gt;
      </noscript>
      <div className="c-page-sub__base">
        <div className="c-page-sub__header">
          <Header />
        </div>
        <div className="c-page-sub__breadcrumb">
          <div className="c-nav-breadcrumb">
            <ol>
              <li className="c-nav-breadcrumb__item"><a href="/">トップ</a></li>
              <li className="c-nav-breadcrumb__item"><a href="/company/">企業情報</a></li>
              <li className="c-nav-breadcrumb__item" data-breadcrumb="current">CM・メディア掲載</li>
            </ol>
          </div>
        </div>
        <div className="c-page-sub__main">
          <main>
            <article>
              <div className="c-page-sub__title-page">
                <div className="c-title-page" data-page="default">
                  <h1><span data-lang="en">MEDIA</span><span data-lang="ja">CM・メディア掲載</span></h1>
                </div>
              </div>
              <div className="c-page-sub__content-main">
                <div className="c-content-main">
                  <section data-type="section" data-mb="small" data-bgcolor="true">
                    <div className="concept-nav">
                      <ul>
                        <li><a href="/company/">企業コンセプト</a></li>
                        <li><a href="/company/about/">会社概要</a></li>
                        <li><a href="/company/office/">事務所・店舗案内</a></li>
                        <li data-current="true">CM・メディア掲載</li>
                      </ul>
                    </div>
                  </section>
                  {/* <section data-type="section">
                    <h2>雑誌掲載情報</h2>
                    <div className="list-magazine">
                      <ul>
                        <li>
                          <figure><img src="/img/pict-book-tocotoco42.jpg" />
                            <figcaption>tocotoco<br />Vol.42</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-mono16.jpg" />
                            <figcaption>monoマガジン<br />2018年4/16号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-letasclub-201804.jpg" />
                            <figcaption>レタスクラブ<br />2018年4月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-orangepage-201804.jpg" />
                            <figcaption>オレンジページ<br />2018年4/2号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-pen-201804.jpg" />
                            <figcaption>Pen<br />2018年4月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lalabegin-201804.jpg" />
                            <figcaption>LaLa Begin<br />2018年4・5月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-2nd-201804.jpg" />
                            <figcaption>2nd<br />2018年4月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-andpremium-201803.jpg" />
                            <figcaption>&amp;Premium<br />2018年3月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lalabegin-201802.jpg" />
                            <figcaption>LaLa Begin<br />2018年2・3月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-goout-201802.jpg" />
                            <figcaption>GO OUT<br />2018年2月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-goout-livin10.jpg" />
                            <figcaption>GO OUT Livin'<br />Vol.10</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-brutus-201801.jpg" />
                            <figcaption>BRUTUS<br />2018年1月1・15合併号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-pen-201801.jpg" />
                            <figcaption>Pen<br />2018年 新年合併号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-oceans-201801.jpg" />
                            <figcaption>OCEANS<br />2018年1月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives96.jpg" />
                            <figcaption>住宅＆インテリアマガジン<br />『LiVES』Vol.96</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-brutus-201712.jpg" />
                            <figcaption>BRUTUS<br />2017年12月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lalabegin-201801.jpg" />
                            <figcaption>LaLa Begin<br />12・1月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-popeye-201712.jpg" />
                            <figcaption>POPEYE<br />2017年12月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-orangepage-201711.jpg" />
                            <figcaption>家族みんなが楽しくなる<br />暮らしのアイディア<br />『オレンジページ』<br />2017年11/17号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-mart-201712.jpg" />
                            <figcaption>Mart<br />2017年12月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lightninghouses.jpg" />
                            <figcaption>LIGHTNING HOUSES</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-andpremium-201712.jpg" />
                            <figcaption>&amp;Premium<br />2017年12月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-ginza-201712.jpg" />
                            <figcaption>GINZA<br />2017年11月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-casa-2018041711.jpg" />
                            <figcaption>Casa BRUTUS<br />2017年11月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-mono-201710.jpg" />
                            <figcaption>新製品情報と時代を読む、男性向けの特集マガジン『monoマガジン』<br />10/16号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lightning-201711.jpg" />
                            <figcaption>Lightning<br />2017年11月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives95.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVES』<br />Vol.95</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lalabegin-201710.jpg" />
                            <figcaption>LaLa Begin<br />10・11月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lightning-201710.jpg" />
                            <figcaption>Lightning<br />2017年10月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives94.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVES』<br />Vol.94</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lalabegin-201708.jpg" />
                            <figcaption>LaLa Begin<br />8・9月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-californiastyle8.jpg" />
                            <figcaption>カリフォルニアスタイル<br />Vol.8</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-orangepage-201707.jpg" />
                            <figcaption>家族みんなが楽しくなる暮らしのアイディア<br />『オレンジページ』<br />2017年7/2号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-relife25.jpg" />
                            <figcaption>別冊住まいの設計<br />『relife+』Vol.25</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-brutus-201705.jpg" />
                            <figcaption>BRUTUS<br />2017/5/15</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-2nd-201706.jpg" />
                            <figcaption>男性ファッション雑誌<br />『2nd（セカンド）』<br />6月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-mono201705.jpg" />
                            <figcaption>新製品情報と時代を読む、男性向けの特集マガジン『monoマガジン』<br />5/2号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lightning-201705.jpg" />
                            <figcaption>Lightning<br />2017年5月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-castyle-201704-vol7.jpg" />
                            <figcaption>カリフォルニアスタイル<br />Vol.7</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-orangepage-201704.jpg" />
                            <figcaption>家族みんなが楽しくなる<br />暮らしのアイディア<br />『オレンジページ』<br />2017年4/2号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-pen-201704-no425.jpg" />
                            <figcaption>男たちのデザイン<br />生活を刺激する<br />クオリティマガジン<br />『Pen』No.425</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives-2017-vol92.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVES』<br />Vol.92</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-relife-vol24.jpg" />
                            <figcaption>別冊住まいの設計<br />『relife+』</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-2nd-201703-vol120.jpg" />
                            <figcaption>男性ファッション雑誌<br />『2nd（セカンド）』<br />vol.120</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lifestyle catalog.jpg" />
                            <figcaption>THE LIFESTYLE CATALOG</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-relife-vol23.jpg" />
                            <figcaption>別冊住まいの設計<br />『relife+』</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-brutus-201612-vol837.jpg" />
                            <figcaption>BRUTUS</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-castyle-201612-vol6.jpg" />
                            <figcaption>カリフォルニアスタイル<br />Vol.6</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives-2016-vol90.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVES』<br />Vol.90</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives-2016-vol88.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVES』<br />Vol.88</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-relife-vol21.jpg" />
                            <figcaption>別冊住まいの設計<br />『relife+』vol.21</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-brutus-201605-vol823.jpg" />
                            <figcaption>BRUTUS<br />Vol.823</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-relife-vol20.jpg" />
                            <figcaption>別冊住まいの設計<br />『relife+』Vol.20</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives-2016-vol85.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVES』<br />Vol.85</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-pen-201611-no416.jpg" />
                            <figcaption>男たちのデザイン<br />生活を刺激する<br />クオリティマガジン<br />『Pen』No.416</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-begin-201611.jpg" />
                            <figcaption>Begin 11月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lalabegin-201610-11.jpg" />
                            <figcaption>LaLa Begin<br />10・11月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-castyle-201608-vol5.jpg" />
                            <figcaption>カリフォルニアスタイル<br />Vol.5</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-elledecor-201608.jpg" />
                            <figcaption>ELLE DECOR<br />（vol.145）</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-monomagazine-201606.jpg" />
                            <figcaption>新製品情報と時代を読む、男性向けの特集<br />『monoマガジン』<br />2016/6/16 情報号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-elledecor-201606.jpg" />
                            <figcaption>ELLE DECOR<br />（vol.144）</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-surftrip-201606.jpg" />
                            <figcaption>Surftrip JOURNAL<br />2016年6月号 Vol.86</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-turns-201606-vol17.jpg" />
                            <figcaption>人、暮らし、地域をつなぐ<br />『TURNS』Vol.17<br />2016[6月]</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-monomagazine-201605.jpg" />
                            <figcaption>新製品情報と時代を読む、男性向けの特集<br />『monoマガジン』<br />特集号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lightning-201605.jpg" />
                            <figcaption>Lightning<br />2016年5月号 Vol.265</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-sumai-201605-vol664.jpg" />
                            <figcaption>住まいの設計<br />（NO.664）</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives-2016-vol86.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVE’S』<br />vol.86</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-orangepage-201603.jpg" />
                            <figcaption>家族みんなが楽しくなる<br />暮らしのアイディア<br />『オレンジページ』<br />2016年3月17号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-goout-vol5.jpg" />
                            <figcaption>別冊GO OUT<br />『GO OUT Livin'』 vol.5</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-tocotoco-2016-vol33.jpg" />
                            <figcaption>子育て、赤ちゃんの<br />情報満載<br />『tocotoco（トコトコ）』<br />vol.33</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-oceans-201602.jpg" />
                            <figcaption>OCEANS<br />2月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-sumai-201601-vol662.jpg" />
                            <figcaption>住まいの設計<br />（NO.662）</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-monomagazine-201511.jpg" />
                            <figcaption>モノ・マガジン<br />（vol.748）</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-fam-2015.jpg" />
                            <figcaption>Fam<br />（Autumn Issue 2015）</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-oceans-201509.jpg" />
                            <figcaption>OCEANS<br />9月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-elledecor-201510.jpg" />
                            <figcaption>ELLE DECOR<br />（vol.140）</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-setagaya-2015-vol53.jpg" />
                            <figcaption>『世田谷ライフmagazine』<br />No.53</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-orangepage-201506.jpg" />
                            <figcaption>家族みんなが楽しくなる暮らしのアイディア<br />『オレンジページ』<br />2015年6月17号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-castyle-vol3.jpg" />
                            <figcaption>カリフォルニアスタイル<br />vol3</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-hajimete.jpg" />
                            <figcaption>はじめての家づくり</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-monomagazine-tokushu.jpg" />
                            <figcaption>新製品情報と時代を読む、男性向けの特集<br />『monoマガジン』<br />特集号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-pen-no379.jpg" />
                            <figcaption>男たちのデザイン<br />生活を刺激する<br />クオリティマガジン<br />『Pen』No.379</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-setagaya-vol52.jpg" />
                            <figcaption>『世田谷ライフmagazine』<br />No.52</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-orangepage-201503.jpg" />
                            <figcaption>家族みんなが楽しくなる暮らしのアイディア<br />『オレンジページ』<br />2015年3月17号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-tocotoco-2015-vol29.jpg" />
                            <figcaption>子育て、赤ちゃんの<br />情報満載<br />『tocotoco（トコトコ）』<br />vol.29</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives-2015-vol79.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVE’S』<br />vol.79</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-orangepage-201501.jpg" />
                            <figcaption>家族みんなが楽しくなる暮らしのアイディア<br />『オレンジページ』<br />2015年1月2号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-monomagazine-201411.jpg" />
                            <figcaption>新製品情報と時代を読む、男性向けの特集<br />『monoマガジン』<br />No.725</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-pen-201411-no370.jpg" />
                            <figcaption>男たちのデザイン<br />生活を刺激する<br />クオリティマガジン<br />『Pen』No.570</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives-2014-vol77.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVE’S』<br />vol.77</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives-2014-vol76.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVE’S』<br />vol.76</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-relife-vol15.jpg" />
                            <figcaption>別冊住まいの設計<br />『relife+』Vol.15</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-orangepage-201406.jpg" />
                            <figcaption>家族みんなが楽しくなる暮らしのアイディア<br />『オレンジページ』<br />2014年6月17号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-ecocolo-2014.jpg" />
                            <figcaption>エコなココロをはぐくむ<br />ライフスタイル誌<br />『エココロ』2014年春夏号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives-2014-vol75.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVE’S』<br />vol.75</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-monomagazine-201405.jpg" />
                            <figcaption>新製品情報と時代を読む、男性向けの特集<br />『monoマガジン』<br />No.713</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-pen-201404-no356.jpg" />
                            <figcaption>男たちのデザイン<br />生活を刺激する<br />クオリティマガジン<br />『Pen』No.356</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives-2014-vol74.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVE’S』<br />vol.74</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-elledecor-201404.jpg" />
                            <figcaption>世界のインテリア雑誌<br />『ELLE DECO』<br />2014年4月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-tocotoco-2014-vol25.jpg" />
                            <figcaption>子育て、赤ちゃんの<br />情報満載<br />『tocotoco（トコトコ）』<br />vol.25</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives-2013-vol72.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVE’S』<br />vol.72</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-ecocolo-2013.jpg" />
                            <figcaption>エコなココロをはぐくむ<br />ライフスタイル誌<br />『エココロ』2013年秋冬号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-pen-201311-no348.jpg" />
                            <figcaption>男たちのデザイン<br />生活を刺激する<br />クオリティマガジン<br />『Pen』No.348</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives-2013-vol71.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVE’S』<br />vol.71</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-turns-201309-vol6.jpg" />
                            <figcaption>人、暮らし、地域をつなぐ<br />『TURNS』<br />vol.06</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-freeandeasy-201309.jpg" />
                            <figcaption>カッコ良く生きる為のライフスタイル提唱誌<br />『Free &amp; Easy（フリーアンドイージー）』<br />2013年9月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-nikkei-201308.jpg" />
                            <figcaption>日経デザイン<br />2013年8月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives-2013-vol70.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVE’S』<br />vol.70</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-kominka-vol19.jpg" />
                            <figcaption>『古民家スタイル』<br />No.19</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives-2013-vol69.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVE’S』<br />vol.69</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-cityjohoooita-201305.jpg" />
                            <figcaption>大分の情報満載！<br />『シティ情報おおいた』<br />2013年5月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-conka-vol97.jpg" />
                            <figcaption>大分のGENKI<br />発掘マガジン<br />『CONKA』vol.97</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-monomagazine-201304.jpg" />
                            <figcaption>新製品情報と時代を読む、男性向けの特集<br />『monoマガジン』<br />No.689</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives-2013-vol68.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVE’S』<br />vol.68</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-conka-vol96.jpg" />
                            <figcaption>大分のGENKI<br />発掘マガジン<br />『CONKA』vol.96</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives-2013-vol67.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVE’S』<br />vol.67</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-pen-201211-no325.jpg" />
                            <figcaption>男たちのデザイン<br />生活を刺激する<br />クオリティマガジン<br />『Pen』No.325</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-conka-vol95.jpg" />
                            <figcaption>大分のGENKI<br />発掘マガジン<br />『CONKA』vol.95</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-cityjohoooita-201301.jpg" />
                            <figcaption>大分の情報満載！<br />『シティ情報おおいた』<br />2013年1月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-cityjohoooita-201210.jpg" />
                            <figcaption>大分の情報満載！<br />『シティ情報おおいた』<br />2012年10月号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-sotocoto-201209.jpg" />
                            <figcaption>ロハスピープルのための<br />快適生活マガジン<br />『ソトコト』No.159</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-freeandeasy-201105.jpg" />
                            <figcaption>カッコ良く生きる為のライフスタイル提唱誌<br />『Free &amp; Easy（フリーアンドイージー）』<br />No.163</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives-2012-vol62.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVE’S』<br />vol.62</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-pen-201204-no310.jpg" />
                            <figcaption>男たちのデザイン<br />生活を刺激する<br />クオリティマガジン<br />『Pen』No.310</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-elledecor-201204.jpg" />
                            <figcaption>世界のインテリア情報<br />『ELLE DECO<br />（エル・デコ）』</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-tocotoco-2011-vol16.jpg" />
                            <figcaption>子育て、赤ちゃんの<br />情報満載<br />『tocotoco』vol.16</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives-2011-vol59.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVE’S』<br />vol.59</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-goliku.jpg" />
                            <figcaption>初心者ゴルファー向けの<br />フリーペーパー<br />『ゴルいく?』vol.3</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-chumonjyutaku-2011.jpg" />
                            <figcaption>注文住宅情報誌<br />『福岡佐賀の注文住宅』<br />2011年春号</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-pen-201104-no287.jpg" />
                            <figcaption>男たちのデザイン<br />生活を刺激する<br />クオリティマガジン<br />『Pen』No.287</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-pen-201011-no279.jpg" />
                            <figcaption>男たちのデザイン<br />生活を刺激する<br />クオリティマガジン<br />『Pen』No.279</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives-2011-vol58.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVE’S』<br />vol.58</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives-2011-vol56.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVE’S』<br />vol.56</figcaption>
                          </figure>
                        </li>
                        <li>
                          <figure><img src="/img/pict-book-lives-2010-vol54.jpg" />
                            <figcaption>住宅 &amp; インテリア<br />マガジン『LiVE’S』<br />vol.54</figcaption>
                          </figure>
                        </li>
                      </ul>
                    </div>
                  </section> */}
                  <section data-type="section">
                    <h2>CMギャラリー</h2>
                    <div className="list-movie">
                      <ul>
                        {/* <li><span data-type="youtube"><iframe src="https://www.youtube.com/embed/xf1JKMvCJNo" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /></span><span data-type="ttl"><a href="https://www.youtube.com/watch?v=xf1JKMvCJNo" target="_blank">ベツダイの不動産ポータル_借り家競走</a></span></li>
                        <li><span data-type="youtube"><iframe src="https://www.youtube.com/embed/bABrNM1wq-U" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /></span><span data-type="ttl"><a href="https://www.youtube.com/watch?v=bABrNM1wq-U" target="_blank">ベツダイの不動産ポータル_二人売却</a></span></li> */}
                        <li><span data-type="youtube"><iframe src="https://www.youtube.com/embed/gDHVXMtR8zo" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /></span><span data-type="ttl"><a href="https://www.youtube.com/watch?v=gDHVXMtR8zo" target="_blank">ZERO-CUBEモデルハウスCM B</a></span></li>
                        <li><span data-type="youtube"><iframe src="https://www.youtube.com/embed/_0bhPuKsGmI" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /></span><span data-type="ttl"><a href="https://www.youtube.com/watch?v=_0bhPuKsGmI" target="_blank">ZERO-CUBEモデルハウスCM A</a></span></li>
                        <li><span data-type="youtube"><iframe src="https://www.youtube.com/embed/uZ0sA2YFxOA" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /></span><span data-type="ttl"><a href="https://www.youtube.com/watch?v=uZ0sA2YFxOA" target="_blank">ZERO-CUBE+FUN 女性篇 30秒</a></span></li>
                        <li><span data-type="youtube"><iframe src="https://www.youtube.com/embed/LfoCYbUzp0w" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /></span><span data-type="ttl"><a href="https://www.youtube.com/watch?v=LfoCYbUzp0w" target="_blank">ZERO-CUBE+FUN 男性篇 30秒</a></span></li>
                        {/* <li><span data-type="youtube"><iframe src="https://www.youtube.com/embed/HS3yOI_xF5g" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /></span><span data-type="ttl"><a href="https://youtu.be/HS3yOI_xF5g" target="_blank">それぞれの週末_篇 120秒</a></span></li>
                        <li><span data-type="youtube"><iframe src="https://www.youtube.com/embed/Lmaw22IV0JY" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /></span><span data-type="ttl"><a href="https://youtu.be/Lmaw22IV0JY" target="_blank">それぞれの週末_篇 60秒</a></span></li>
                        <li><span data-type="youtube"><iframe src="https://www.youtube.com/embed/tdrJ8J1GINk" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /></span><span data-type="ttl"><a href="https://youtu.be/tdrJ8J1GINk" target="_blank">親子の距離_篇 15秒</a></span></li>
                        <li><span data-type="youtube"><iframe src="https://www.youtube.com/embed/eSQV8cXIYEE" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /></span><span data-type="ttl"><a href="https://youtu.be/eSQV8cXIYEE" target="_blank">家というものは_篇 15秒</a></span></li> */}
                      </ul>
                    </div>
                  </section>
                </div>
              </div>
            </article>
          </main>
        </div>
        <div className="c-page-sub__footer">
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default CompanyMediaPage
